import { _ } from "libs";

import React, { Component } from "react";
import { Form, Field } from "react-final-form";
import { Rating, Profile, Ratings } from "../../types";
import SkillSelect from "../forms/controls/skillSelect";

type FormProps = {
	onChange: Function;
	profile: Profile;
	ratings: Ratings;
};

export class SkillForm extends Component<FormProps> {
	render() {
		return (
			<Form
				onSubmit={({ rating }: { rating: Rating }, mutators) => {
					this.props.onChange({ rating });
				}}
				initialValues={this.props.profile}
				render={({ handleSubmit, submitting, pristine, invalid, values }) => (
					<form onSubmit={handleSubmit}>
						<Field name="rating">
							{({ input, meta, ...rest }) => (
								<div>
									<label>{_("onboarding.skill.label")}</label>
									<SkillSelect
										{...{
											input,
											meta,
											ratings: this.props.ratings,
											officialRating: this.props.profile.rating.officialRating,
											userId: this.props.profile.userId,
											...rest,
										}}
									/>
									{meta.touched && meta.error && <span>{meta.error}</span>}
								</div>
							)}
						</Field>
						<div className="buttons">
							<button type="submit" className="button" disabled={submitting}>
								{_("onboarding.btnComplete.label")}
							</button>
						</div>
					</form>
				)}
			/>
		);
	}
}

export default SkillForm;
